import React from 'react';
import goldcleats_studios from "../assets/goldcleats_studios.png"

function Footer() {
    // Get the current year
    const currentYear = new Date().getFullYear();
    return (
        <footer className="bg-light py-4">
            <div className="container text-center color-white">
                {/* <p className="mb-3">The leading mobile App for youth players</p> */}
                <div className="d-flex justify-content-center align-items-center mb-3">
                    <a href="//www.goldcleats.com" target="_blank" rel="noreferrer" className="mx-2">
                        <img
                            src={goldcleats_studios}
                            alt="GoldCleats Logo"
                            width="250"

                        />
                    </a>
                    {/* <a href="https://itunes.apple.com/us/app/goldcleats/id1134964817?ls=1&mt=8" target="_blank" rel="noreferrer" className="mx-2">
                        <img src="https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/player/appstore.png?crc=09122021" alt="Download on the App Store" style={{ width: '170px' }} />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.goldCleats.GoldCleats" target="_blank" rel="noreferrer" className="mx-2">
                        <img src="https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png" alt="Get it on Google Play" style={{ width: '200px' }} />
                    </a> */}
                </div>
                <p className="mb-0">&copy; {currentYear} GoldCleats. All Rights Reserved.</p>
            </div>
        </footer>

    );
}

export default Footer;
